module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/7735505170f95f4b098a2e47c145643d.svg";